import React from 'react';
import flex from '../css/module/flex.css';

export const StepContent: React.FC = ({ children }) => (
  <div className={`${flex.alignItemsCenter} ${flex.wrap}`}>{children}</div>
);

export default StepContent;
